import { Link } from "@/i18n/navigation";
import { Button, ButtonProps } from "../ui/button";
import { cn } from "@/lib/utils";
import { HTMLAttributeAnchorTarget, MouseEventHandler } from "react";

export const NavButton = ({
  href,
  linkTarget,
  className,
  onLinkClick,
  ...buttonProps
}: ButtonProps & {
  linkTarget?: HTMLAttributeAnchorTarget;
  href?: string | null;
  onLinkClick?: MouseEventHandler<HTMLAnchorElement>;
}) => {
  if (!href) {
    return (
      <Button
        {...buttonProps}
        onClick={onLinkClick as ButtonProps["onClick"]}
      />
    );
  }

  return (
    <Link
      href={href}
      prefetch
      className={cn(className, "mx-auto mt-5 w-full no-underline")}
      target={linkTarget}
      onClick={onLinkClick}
    >
      <Button {...buttonProps} />
    </Link>
  );
};
